import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDirectionChevronDown24 = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M1 6C6.43 6.565 11.815 14.1 12 18C12.18 14.1 17.57 6.565 23 6" stroke="currentColor" strokeWidth={1.2} /></svg>;
const ForwardRef = forwardRef(SvgDirectionChevronDown24);
export default ForwardRef;